import React, {useEffect, useState} from 'react';
import {Button, Card, CardBody, CardHeader, Col, Container, Row} from "reactstrap";
import {useHistory} from "react-router-dom";
import {collection, getDocs, query} from 'firebase/firestore';
import {getDb} from 'util/Constants';
import character from "../../assets/img/backgrounds/step2Character.png";
import PrevArrowImage from "../../assets/img/icons/user/prevArrow.png";
import NextArrowImage from "../../assets/img/icons/user/nextArrow.png";
import competencyActive from "../../assets/img/icons/user/card-sidebar/competency-active.png";
import competencyInactive from "../../assets/img/icons/user/card-sidebar/competency-inactive.png";
import cognitiveActive from "../../assets/img/icons/user/card-sidebar/cognitive-active.png";
import cognitiveInctive from "../../assets/img/icons/user/card-sidebar/cognitive-inactive.png";
import aptitudeActive from "../../assets/img/icons/user/card-sidebar/aptitude-active.png";
import aptitudeInctive from "../../assets/img/icons/user/card-sidebar/aptitude-inactive.png";
import closeIcon from "../../assets/img/icons/user/close.png";
import cancelIcon from "../../assets/img/icons/user/cancel.png";

const image = "https://firebasestorage.googleapis.com/v0/b/progressgame-assessment-v1.appspot.com/o/Mask%20group.png?alt=media&token=4ca820a1-f540-499c-99a5-b72627a934ae&_gl=1*1dyh918*_ga*MTM1OTMxMDA0NS4xNjc4NDIyOTY3*_ga_CW55HF8NVT*MTY4NTk1ODE4OS42MC4xLjE2ODU5NTgxOTcuMC4wLjA."

const Step2 = (props) => {
    const [activeTab, setActiveTab] = useState("tab1");
    const [showDetailBubble, setShowDetailBubble] = useState(true);
    const [competencies, setCompetencies] = useState([]);
    const [selectedLevels, setSelectedLevels] = useState(
        { competencies: [], cognitive: [], aptitude: [] });
    const [levelCount, setLevelCount] = useState(null);
    const history = useHistory();
    useEffect(() => {
        getAbilities();
    }, [])

    const getAbilities = async () => {
        const dataArr = [];
        const q = query(collection(getDb(), "Metadata_Ability"));
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
            dataArr.push({ ...doc.data() });
        });

        setCompetencies(dataArr)
    };




    const cognitive = [
        {
            name: "Mini 4",
            secondName: "Set the shelf",
            description: "bsbcjhsbcjhbcdb",
        },
    ];
    const aptitude = [
        {
            name: "Mini 3",
            secondName: "Scramble",
            description: "bsbcjhsbcjhbcdb",
        },

        {

            name: "Mini 5",
            secondName: "Problem Solving",
            description: "bsbcjhsbcjhbcdb",
        },



    ];

    useEffect(() => {
        const count = selectedLevels.competencies.length + selectedLevels.cognitive.length + selectedLevels.aptitude.length;
        setLevelCount(count);
    }, [selectedLevels]);
    useEffect(() => {
        if (props.userData.levels) {
            setSelectedLevels(props.userData.levels);
        }
    }, [])

    const addTest = (type, item) => {
        setSelectedLevels({ ...selectedLevels, [type]: [...selectedLevels[type], item] });
    }
    const deleteTest = (type, item) => {

        let data = { ...selectedLevels };
        const index = data[type].findIndex(element => element.name === item.name);

        data[type].splice(index, 1);

        setSelectedLevels({ ...data });
    }
    const handleSubmit = () => {
        props.setUserData({ ...props.userData, eventData: { ...props.userData.eventData, selectedCompetencies: selectedLevels }, levels: selectedLevels });

        history.push("/easy-flow/step3");
    }
    const previous = () => {
        history.goBack();
    }

    return (
        <div>
            <Container>
                <div className="d-flex justify-content-center">
                    <div className="d-none d-lg-block mb--150 ml--10 character">
                        <div className="d-flex">
                            <div className="max-z-index">
                                <img src={character} width={201} />
                            </div>
                            <div className="bubble">
                                <div className="bubble-text position-relative">
                                    <p className="text-break text-center">Hi, Pharetra pelle ntes que mi leo id
                                        est ornare. Libero nunc gravida at mattis. Facilisi
                                        consectetur
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Card className="mt--75 innerCard br-60" style={{ display: 'flex', flexDirection: 'row' }}>
                        <CardHeader className="card-headers text-nowrap">
                            <div
                                className="d-flex flex-column justify-content-between h-100 py-3">
                                <div role="button" onClick={() => {
                                    setActiveTab("tab1")
                                }}>
                                    <div>
                                        <img src={activeTab === "tab1" ? competencyActive : competencyInactive}
                                            alt="icon" />
                                    </div>
                                    <div>
                                        <span>Competency <br /> Assessment</span>
                                    </div>
                                </div>
                                <div role="button" onClick={() => {
                                    setActiveTab("tab2")
                                }}>
                                    <div>
                                        <img src={activeTab === "tab2" ? cognitiveActive : cognitiveInctive}
                                            alt="icon" />
                                    </div>
                                    <div>
                                        <span>Cognitive Ability <br /> Assessment</span>
                                    </div>
                                </div>
                                <div role="button" onClick={() => {
                                    setActiveTab("tab3")
                                }}>
                                    <div>
                                        <img src={activeTab === "tab3" ? aptitudeActive : aptitudeInctive} alt="icon" />
                                    </div>
                                    <div>
                                        <span>Aptitude <br /> Assessment</span>
                                    </div>
                                </div>
                            </div>
                        </CardHeader>
                        <CardBody>
                            <Container className="assessment-container">
                                <Row>
                                    {activeTab === "tab1" &&
                                        competencies.map((item, index) => (
                                            <Col lg={4} md={4} sm={12} xs={12} key={index}>
                                                <div className="slide-item">
                                                    <img src={image} width="100%" />
                                                    <Row className="mt-2">
                                                        <Col className="text-center" lg={6}>
                                                            <span className="text-sm font-weight-600 text-dark">
                                                                {item.name}
                                                            </span>
                                                        </Col>
                                                        <Col className="text-center" lg={6}>
                                                            <Button size="sm" className="add-test-button text-white"
                                                                disabled={levelCount >= 10}
                                                                color=""
                                                                onClick={() => addTest("competencies", item)}>
                                                                Add Test</Button>
                                                        </Col>
                                                    </Row>
                                                    {/*<div className="d-flex justify-content-between mt-2 align-items-center">*/}
                                                    {/*</div>*/}
                                                </div>
                                            </Col>
                                        ))}
                                    {activeTab === "tab2" &&
                                        cognitive.map((item, index) => (
                                            <Col lg={4} md={4} sm={12} xs={12} key={index}>
                                                <div className="slide-item">
                                                    <img src={image} width="100%" />
                                                    <Row className="mt-2">
                                                        <Col className="text-center">
                                                            <span className="text-sm font-weight-600 text-dark">
                                                                {item.secondName}
                                                            </span>
                                                        </Col>
                                                        <Col className="text-center">
                                                            <Button size="sm" className="add-test-button text-white"
                                                                color="" disabled={levelCount >= 10}
                                                                onClick={() => addTest("cognitive", item)}> Add
                                                                Test</Button>
                                                        </Col>
                                                    </Row>
                                                    {/*<div className="d-flex justify-content-between mt-2 align-items-center">*/}
                                                    {/*    */}
                                                    {/*</div>*/}
                                                </div>
                                            </Col>
                                        ))}
                                    {activeTab === "tab3" &&
                                        aptitude.map((item, index) => (
                                            <Col lg={4} md={4} sm={12} xs={12} key={index}>
                                                <div className="slide-item">
                                                    <img src={image} width="100%" />
                                                    <Row className="mt-2">
                                                        <Col className="text-center">
                                                            <span className="text-sm font-weight-600 text-dark">
                                                                {item.secondName}
                                                            </span>
                                                        </Col>
                                                        <Col className="text-center">
                                                            <Button size="sm" className="add-test-button text-white"
                                                                color="" disabled={levelCount >= 10}
                                                                onClick={() => addTest("aptitude", item)}> Add
                                                                Test</Button>
                                                        </Col>
                                                    </Row>
                                                    {/*<div className="d-flex justify-content-between mt-2 align-items-center">*/}
                                                    {/*</div>*/}
                                                </div>
                                            </Col>
                                        ))}
                                </Row>
                            </Container>
                            <Container className="mt-4">
                                <Row>
                                    <Col sm={12} xs={12} md={3} lg={3}>
                                        <Button className="previous-button text-white w-100" onClick={previous}
                                            color="">Previous</Button>
                                    </Col>
                                    <Col sm={12} xs={12} md={6} lg={6}></Col>
                                    <Col sm={12} xs={12} md={3} lg={3}>
                                        <Button className="nextButton px-sm-0 border-0 text-white px-5 w-100"
                                            onClick={handleSubmit}
                                            color="">Next</Button>
                                    </Col>
                                </Row>
                            </Container>
                        </CardBody>
                        {showDetailBubble && (
                            <div className="detail-bubble d-none d-lg-block">
                                <div className="text-right">
                                    <img src={closeIcon} alt="" role="button"
                                        onClick={() => {
                                            setShowDetailBubble(false);
                                        }} />
                                </div>
                                <div className="pl-3 pt-3 pb-3 pr-0">
                                    <h3 className="font-weight-bolder">Your Selected Assessments</h3>
                                    {Object.keys(selectedLevels).map((ability, mainIndex) => (
                                        <div className="py-1" key={mainIndex}>
                                            <h4 className="text-capitalize" style={{ color: "#006CD9" }}>{ability}</h4>
                                            {selectedLevels[ability].map((item, index) => (
                                                <div key={index} className="d-flex mb-2">
                                                    <div>
                                                        <span className="font-weight-600 fs-14">{ability === 'competencies' ? item.name : item.secondName}</span>
                                                    </div>
                                                    <div className="ml-2">
                                                        <img src={cancelIcon} role="button"
                                                            onClick={() => deleteTest(ability, item)} />
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    ))}
                                    <div>
                                        <h2>Total Assessments Selected : <span
                                            style={{ color: "#3E5B86" }}>{levelCount}</span></h2>
                                        <Button className="nextButton border-0 text-white w-100 mt-4"
                                            onClick={handleSubmit}
                                            color="">Next</Button>
                                    </div>
                                </div>
                            </div>
                        )}
                        {!showDetailBubble && (
                            <div className="button-wrapper">
                                <button className="collapseNext" onClick={() => {
                                    setShowDetailBubble(true)
                                }}>
                                    <div className="line one">
                                        <div className="dot"></div>
                                        <div className="dot"></div>
                                        <div className="dot"></div>
                                        <div className="dot"></div>
                                    </div>
                                    <div className="line two">
                                        <div className="dot"></div>
                                        <div className="dot"></div>
                                        <div className="dot"></div>
                                        <div className="dot"></div>
                                    </div>
                                    <div className="line three">
                                        <div className="dot"></div>
                                        <div className="dot"></div>
                                        <div className="dot"></div>
                                        <div className="dot"></div>
                                    </div>
                                    <div className="line four">
                                        <div className="dot"></div>
                                        <div className="dot"></div>
                                        <div className="dot"></div>
                                        <div className="dot"></div>
                                    </div>
                                    <div className="line five">
                                        <div className="dot"></div>
                                        <div className="dot"></div>
                                        <div className="dot"></div>
                                        <div className="dot"></div>
                                    </div>
                                    <div className="line six">
                                        <div className="dot"></div>
                                        <div className="dot"></div>
                                        <div className="dot"></div>
                                        <div className="dot"></div>
                                    </div>
                                    <div className="line seven">
                                        <div className="dot"></div>
                                        <div className="dot"></div>
                                        <div className="dot"></div>
                                        <div className="dot"></div>
                                    </div>
                                </button>
                            </div>
                        )}
                    </Card>
                </div>
            </Container>
        </div>
    );
};

export default Step2;

function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div onClick={onClick}>
            <img src={NextArrowImage} alt="Next" className={`${className}`}
                style={{ ...style, display: "block", width: "auto", height: "auto" }} />
        </div>

    );
}

function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div onClick={onClick}>
            <img src={PrevArrowImage} alt="Next" className={`${className}`}
                style={{ ...style, display: "block", width: "auto", height: "auto" }} />
        </div>
    );
}